import React from 'react'
import { Popup } from 'semantic-ui-react'

export default function MoreInfoPopup({ content }) {
  return <Popup trigger={<i className='moreinfoicon' alt='' />} content={content} offset={13} />
}
